export const COLORS = {
    white: '#ffffff',
    black: '#000000',
    bk_gd:'#ff9933',
    blue:'#000080',
    black_light:'#878787',
  }
  export default COLORS;